(function() {
    let stylesLoaded = false;

    window.c24.lp.overlay = {

        loadStyles: function() {

            const link = document.createElement('link');
            link.href = window.c24LpRoot + 'css/' + (window.c24LpIsMobile ? 'mobile' : 'desktop') + '/scss/components/erstinfo-overlay.min.css?v=' + window.c24LpTime;
            link.type = 'text/css';
            link.rel = 'stylesheet';
            link.media = 'screen,print';

            document.getElementsByTagName('head')[0].appendChild(link);

            stylesLoaded = true;
        },

        showErstinfoOverlay: function(infoElement, callback) {

            if (!stylesLoaded) {
                window.c24.lp.overlay.loadStyles();
            }

            const contentName = window.c24LpIsMobile ? '.c24m-page-content' : '#c24-content';
            const errorDiv = window.c24LpIsMobile ? '.InitialNoticeOverlay-footer-checkboxContainer-errorText' : '.InitialNoticeOverlay-window-form-checkboxContainer-errorText';

            const overlay = $($.parseHTML(window.c24.lp.overlay.template));
            overlay.insertAfter(contentName);

            $('.CheckboxInput-row', overlay).on('click', function() {

                if ($('.CheckboxInput-icon', this).hasClass('checked')) {

                    $('.CheckboxInput-icon', this).removeClass('checked');
                    infoElement.data('erstinfo-done', 0);
                    $(errorDiv, overlay).show();

                } else {
                    $('.CheckboxInput-icon', this).addClass('checked');
                    infoElement.data('erstinfo-done', 1);
                    $(errorDiv, overlay).hide();
                }
            });

            $('.NavigationButton-button', overlay).on('click', function() {

                if (!infoElement.data('erstinfo-done')) {
                    $(errorDiv, overlay).show();
                    return;
                }

                $('body').css('overflow', 'visible');
                overlay.addClass('c24Hidden');
                $(contentName).removeClass('blurryContent');

                if (callback) {
                    callback();
                }
            });

            $(window).scrollTop(0);

            $(contentName).addClass('blurryContent');
            overlay.removeClass('c24Hidden');
            $('body').css('overflow', 'hidden');
        },
    };

})();
